export const MAX_DELETE_STUDENTS = 100;
export const DELETE_PENDING_KEY = "eduprime.pendingStudentDeletion";
export const deletionPendingKey = actor => DELETE_PENDING_KEY + "." + encodeURIComponent(String(actor));
export function canDeleteStudents(account) {
  return !!account && [1, 4, 6].includes(Number(account.idRole)) &&
    account.idSekolah == null && account.idDinasPemda == null && account.idDinas == null;
}
export function parseStudentUsernames(text, csv = false) {
  if (typeof text !== "string" || text.length > 20000) throw new Error("Isi daftar terlalu panjang.");
  const lines = text.replace(/^\uFEFF/, "").split(/\r?\n/).map(value => value.trim()).filter(Boolean);
  if (csv && (!lines.length || lines.shift().toLowerCase() !== "username")) throw new Error("CSV harus memiliki satu kolom dengan judul username.");
  if (!lines.length || lines.length > MAX_DELETE_STUDENTS) throw new Error("Masukkan 1–100 username, satu username per baris.");
  if (lines.some(value => value.length > 100 || /[\s,;"\u0000-\u001f\u007f-\u009f]/.test(value))) throw new Error("Setiap baris hanya boleh berisi satu username, tanpa spasi, tanda kutip atau kolom tambahan.");
  if (new Set(lines.map(value => value.toLowerCase())).size !== lines.length) throw new Error("Ada username ganda. Hapus baris yang berulang terlebih dahulu.");
  return lines;
}
export function validDeleteReason(reason) {
  return typeof reason === "string" && reason.trim().length >= 10 && reason.trim().length <= 250 && !/[\u0000-\u001f\u007f-\u009f]/.test(reason);
}
export function deletionResponse(response) {
  const body = response && response.data;
  if (!body || !body.errorSchema || body.errorSchema.errorCode !== "EP-000" || !body.data) {
    const error = new Error(body && body.errorSchema && body.errorSchema.errorMessage || "Respons layanan belum dapat dikonfirmasi.");
    error.response = response; throw error;
  }
  return body.data;
}
export function deletionFailure(error) {
  const response = error && error.response;
  const body = response && response.data;
  if (response && response.status === 403) return "Akun ini tidak berhak menghapus akun siswa.";
  if (response && response.status === 401) return "Sesi berakhir. Masuk kembali dengan akun admin yang sama, lalu periksa hasil permintaan.";
  return body && body.errorSchema && body.errorSchema.errorMessage || error && error.message || "Layanan belum dapat dihubungi.";
}
export function validDeletionReceipt(receipt, request) {
  const positiveId = value => Number.isSafeInteger(value) && value > 0;
  return !!receipt && !!request && receipt.requestId === request.requestId && receipt.previewToken === request.previewToken &&
    Number.isSafeInteger(receipt.deletedCount) && receipt.deletedCount > 0 && receipt.deletedCount <= MAX_DELETE_STUDENTS &&
    Number.isSafeInteger(receipt.returnedVoucherCount) && receipt.returnedVoucherCount >= 0 &&
    Array.isArray(receipt.studentIds) && receipt.studentIds.length === receipt.deletedCount &&
    receipt.studentIds.every(positiveId) && new Set(receipt.studentIds).size === receipt.studentIds.length &&
    Array.isArray(receipt.schoolIds) && receipt.schoolIds.length === 1 && receipt.schoolIds.every(positiveId) &&
    typeof receipt.completedAt === "string" && Number.isFinite(Date.parse(receipt.completedAt));
}

export function validDeletionPreview(preview, usernames) {
  if (!preview || typeof preview.canExecute !== "boolean" || !Array.isArray(preview.students) ||
      preview.students.length !== usernames.length || !preview.summary) return false;
  const expected = usernames.map(value => value.toLowerCase()).sort();
  const actual = preview.students.map(row => typeof row.username === "string" ? row.username.toLowerCase() : "").sort();
  if (expected.some((value, index) => value !== actual[index])) return false;
  if (preview.students.some(row => typeof row.eligible !== "boolean" || !Array.isArray(row.reasons) ||
      !row.reasons.every(reason => typeof reason === "string" || (reason && typeof reason.message === "string")) ||
      [row.namaSiswa, row.namaSekolah, row.namaKelas, row.activationStatus, row.note].some(value => value != null && typeof value !== "string") ||
      (row.voucherCount != null && (!Number.isSafeInteger(row.voucherCount) || row.voucherCount < 0)))) return false;
  const eligible = preview.students.filter(row => row.eligible).length;
  if (preview.summary.total !== usernames.length || preview.summary.eligible !== eligible ||
      preview.summary.blocked !== usernames.length - eligible ||
      !Number.isSafeInteger(preview.summary.vouchersToReturn) || preview.summary.vouchersToReturn < 0) return false;
  return !preview.canExecute || (eligible === usernames.length && typeof preview.previewToken === "string" &&
    !!preview.previewToken && Number.isFinite(Date.parse(preview.expiresAt)) &&
    preview.students.every(row => Number.isSafeInteger(row.idSiswa) && row.idSiswa > 0) &&
    new Set(preview.students.map(row => row.idSiswa)).size === preview.students.length);
}
